import { render, staticRenderFns } from "./DirDayModule.vue?vue&type=template&id=8f8b5f04&"
import script from "./DirDayModule.vue?vue&type=script&lang=js&"
export * from "./DirDayModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports